import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { ENV } from '../env';
import AuthForm from './components/AuthForm.vue';
import ConnectModal from './components/ConnectModal.vue';
import Settings from './components/Settings.vue';
import Chat from './components/Chat.vue';
import { getPersisted, LANG, persist, store, STORE_KEY } from './store';
import PowerSimulator from './components/PowerSimulator.vue';
import QuizCardModal from './components/QuizCardModal.vue';
import { i18n } from './assets/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props, { expose: __expose }) {
  __expose();

const version = require('../package.json').version;

const token = ref(getPersisted<string>(STORE_KEY.TOKEN) || ENV[0].TOKEN);

const error = ref<string | undefined>();

const percent = ref<number>(0);

const showCardModal = ref(false);

const showSettings = ref(false);

document.addEventListener('keydown', function (event) {
  if (showCardModal.value && event.key == 'Enter') {
    showCardModal.value = false;
  } else if (event.key == 'Enter' && store.textInput == '') {
    showCard();
  }
});

// fast hack for displaying settings
showSettings.value = window.location.search.includes('settings=true');

/**
 * Calculates the header buttons
 */
function getHeaderButtons() {
  return [
    {
      icon: '🀙',
      title: store.cardDrawn ? i18n('NEW_CARD') : i18n('SHOW_CARD'),
      action: showCard,
      style: store.cardDrawn
        ? 'text-shadow: #fac300 0px 0 3px; line-height: 1.8em;'
        : 'line-height: 1.8em;'
    },
    {
      icon: '⟲',
      title: i18n('RESET'),
      action: resetUser,
      style: ''
    },
    {
      icon: store.lang === LANG.DE ? '🇩🇪' : '🇫🇷',
      title: i18n('LANGUAGE'),
      action: toggleLanguage,
      style: 'filter: saturate(0)'
    }
    // {
    //   icon: '⚙︎',
    //   title: 'Einstellungen',
    //   action: () => (showSettings.value = !showSettings.value),
    //   style: '',
    // },
  ];
}

/**
 * Sets the token recieved from authentication
 * @param t    object with the new token and a boolean value
 *             that defines if the token should be persistet to local storage
 */
function setToken(t: { token: string; persist: boolean }) {
  token.value = t.token;
  if (t.persist) {
    persist(STORE_KEY.TOKEN, token.value);
  }
}

/**
 * Toggles the language between DE and FR
 */
function toggleLanguage() {
  switch (store.lang) {
    case LANG.DE:
      store.lang = LANG.FR;
      break;
    case LANG.FR:
      store.lang = LANG.DE;
      break;
  }
}

/**
 * Resets the app to start with a new user
 */
function resetUser() {
  if (confirm(i18n('RESET_USER'))) {
    store.resetUser();
  }
}

/**
 * Resets the whole app
 */
function reset() {
  store.resetUser();
  error.value = undefined;
  token.value = ENV[0].TOKEN;
}

/**
 * Draws a new quiz card and sets the example prompts.
 */
function showCard() {
  store.drawQuizCard();
  store.setExamplePromptsVisible(true);
  showCardModal.value = true;
}

/**
 * Closes the settings window
 */
function closeSettings() {
  showSettings.value = false;
  window.location.search = 'settings=' + showSettings.value;
}

/**
 * Handles an error and displays it to the user
 * @param error   the error message to display to the user
 */
function handleError(e: string = i18n('UNKNOWN_ERROR')) {
  error.value = e;
}

/**
 * Calculates the css opacity for a given toast message
 * @param i the position of the toast message
 */
function getToastOpacity(i: number): string {
  return 'opacity: ' + (i + 1) / store.toasts.length;
}

const __returned__ = { version, token, error, percent, showCardModal, showSettings, getHeaderButtons, setToken, toggleLanguage, resetUser, reset, showCard, closeSettings, handleError, getToastOpacity, AuthForm, ConnectModal, Settings, Chat, get store() { return store }, PowerSimulator, QuizCardModal, get i18n() { return i18n } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})